export default __webpack_public_path__ + "static/media/img-community-modal.504bb176.png";